import { render, staticRenderFns } from "./DarkPage.vue?vue&type=template&id=27255003"
import script from "./DarkPage.vue?vue&type=script&lang=js"
export * from "./DarkPage.vue?vue&type=script&lang=js"
import style0 from "./DarkPage.vue?vue&type=style&index=0&id=27255003&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports